"use client";

import { useStore as useZustandStore } from "zustand";
import { StoreContext } from "@layout-components/GlobalProvider";
import { useContext } from "react";
import { usePost } from "@/hooks/useRequest";

interface IStore {
  nickname: string;
  permissionList: string[];
  gender: string;
  email: string;
  avatar: string;
  phone: string;
  roleList: string[];
  username: string;
  permissionTree: any[];
  dics: any[];
  refetchPermissionList: () => void;
  isFullScreen: boolean;
  setIsFullScreen: (isFullScreen: boolean) => void;
}

interface IOptions {
  type: 'select' | 'dics';
  params?: Record<string, any>;
}
// 导出 useStore hook
export const useStore = <T>(selector: (state: IStore) => T): T => {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error("useStore must be used within StoreProvider");
  }

  return useZustandStore(store, selector);
};

export const useDics = (key: string, params?: Record<string, any>) => {
  const dics = useStore((state) => state.dics);

  const enumItemList =
    dics?.find((item) => item.enumKey === key)?.enumItemList || [];
  const { data: optionList } = usePost(
    "/manage/exhibition/resource/v1/queryCommonOptionList",
    {
      code: key,
      params: params || {},
    },
    {
      enabled: !enumItemList.length && key?.toUpperCase() === key,
    },
  );
  const { data } = usePost(
    "/manage/common/resource/v1/queryGeneralDictList",
    { dictCode: key },
    {
      enabled: !enumItemList.length && key?.toUpperCase() !== key,
    },
  );


  // const records  = data?.records?.map((item: { name: string; code: string }) => ({
  //   label: item.name,
  //   value: item.code,
  // })) || []
  if (enumItemList?.length > 0) {
    return enumItemList;
  }
  if (key?.toUpperCase() === key) {
    return optionList || [];
  }
  return data || [];
};
